<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;height: 500px;">
			<div id="container"></div>
		</div>
		<div style="width: 100%;display: flex;align-items: center;">
			<div style="width: 40%;">
			</div>
			<!-- <div class=""
				style="margin: 20px;font-size: 24px; font-weight: bold; line-height: 33px; color: #FFFFFF;
				width: 60%;
				height: 40px;
				background: url('https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181612497.png') no-repeat;
				background-size: 293px 33px;">
				设备状态
			</div> -->
			<div class="title-img" style="margin: 20px 0 0 20px;">
				<div class="title">设备状态</div>
			</div>
		</div>
		<div style="width: 100%;display: flex;align-items: center;">
			<div style="width: 40%;height: 349px;
			background: url('https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1721031354673.png')no-repeat;
			background-size: 100% 100%;">
				<div style="padding: 0 40px;">
					<div class=""
						style="font-size: 18px; font-weight: 500; line-height: 19px; display: flex;justify-content: space-between;align-items: center;">
						<div style="color: #FFFFFF;">
							{{remoteDeviceListOptFor.remoteDeviceName}}
						</div>
						<div v-if="remoteDeviceListOptFor.remoteDeviceState==2" style="color: #00FFE7;display: flex;align-items: center;">
							已开启 <h1 style="margin-left: 4px;">·</h1>
						</div>
						<div v-else style="color: #ed5565;display: flex;align-items: center;">
							离线 <h1 style="margin-left: 4px;">·</h1>
						</div>
					</div>
					<div style="display: flex; align-items: center;">
						<div class="" style="font-size: 14px; font-weight: 500; line-height: 25px; color: #FFFFFF;">
							直通（1控1）
						</div>
						<div
							style="margin-left: 8px;display: flex; align-items: center; font-size: 14px; font-weight: 400; line-height: 12x; color: #FFFFFF;">
							<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1721033368154.png"
								style="width: 13px;height: 13px;" alt="" />
							<div style="margin-left: 4px;">强</div>
							<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1721033379303.png"
								style="width: 17.5px;height: 9.54px;margin-left: 7px;" alt="" />
							<div style="margin-left: 4px;">{{remoteDeviceListOptFor.ballValve13}}%</div>
						</div>
					</div>
					<div v-if="devType=='dev-zt1_1'">
						<div style="margin-top: 10px;display: flex; justify-content: center; align-items: center;">
							<img src="@/assets/img/dev-zt1_1.png"
								style="width: 223px;height: 125px;object-fit: contain;" alt="" />
						</div>
						<div style="margin-top: 30px;display: flex; justify-content: center; align-items: center;">
							<div style="width: 388px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
						</div>
						<div class=""
							style="margin-top: 7px;display: flex; justify-content: center; align-items: center;font-size: 12px; font-weight: 400; line-height: 11.7px; color: #FFFFFF;">
							<div class=""
								style="width: 388px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
						</div>
					</div>
					<div v-if="devType=='dev-zt1_2'">
						<div style="margin-top: 10px;display: flex; justify-content: center; align-items: center;">
							<img src="@/assets/img/dev-zt1_2.png"
								style="width: 408px;height: 129.72px;object-fit: contain;" alt="" />
						</div>
						<div
							style="margin-top: 30px;display: flex; justify-content: space-around; align-items: center;">
							<div style="width: 180px;">
								<el-progress :percentage="remoteDeviceListOptFor.ballValve12" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
							<div style="width: 180px;">
								<el-progress :percentage="remoteDeviceListOptFor.ballValve11" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
						</div>
						<div class=""
							style="margin-top: 7px;display: flex; justify-content: space-around; align-items: center;font-size: 12px; font-weight: 400; line-height: 11.7px; color: #FFFFFF;">
							<div class=""
								style="width: 180px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">{{remoteDeviceListOptFor.ballValve12?remoteDeviceListOptFor.ballValve12:'0'}}%</div>
								<div>开 100%</div>
							</div>
							<div class=""
								style="width: 180px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">{{remoteDeviceListOptFor.ballValve11?remoteDeviceListOptFor.ballValve11:'0'}}%</div>
								<div>开 100%</div>
							</div>
						</div>
					</div>
					<div v-if="devType=='dev-zt7'">
						<div style="margin-top: 10px;display: flex; justify-content: center; align-items: center;">
							<img src="@/assets/img/dev-zt7.png" style="width: 233px;height: 129px;object-fit: contain;"
								alt="" />
						</div>
						<div style="margin-top: 30px;display: flex; justify-content: center; align-items: center;">
							<div style="width: 388px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
						</div>
						<div class=""
							style="margin-top: 7px;display: flex; justify-content: center; align-items: center;font-size: 12px; font-weight: 400; line-height: 11.7px; color: #FFFFFF;">
							<div class=""
								style="width: 388px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
						</div>
					</div>
					<div v-if="devType=='dev-ztt'">
						<div style="margin-top: 10px;display: flex; justify-content: center; align-items: center;">
							<img src="@/assets/img/dev-zt7.png" style="width: 305px;height: 129px;object-fit: contain;"
								alt="" />
						</div>
						<div style="margin-top: 30px;display: flex; justify-content: center; align-items: center;">
							<div style="width: 388px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
						</div>
						<div class=""
							style="margin-top: 7px;display: flex; justify-content: center; align-items: center;font-size: 12px; font-weight: 400; line-height: 11.7px; color: #FFFFFF;">
							<div class=""
								style="width: 388px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
						</div>
					</div>
					<div v-if="devType=='dev-zt1_4'">
						<div style="display: flex; justify-content: center; align-items: center;">
							<img src="@/assets/img/dev-zt1_4.png"
								style="width: 333px;height: 169px;object-fit: contain;" alt="" />
						</div>
						<div style="margin-top: 7px;display: flex; justify-content: space-around; align-items: center;">
							<div style="width: 180px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
							<div style="width: 180px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
						</div>
						<div class=""
							style="margin-top: 3px;display: flex; justify-content: space-around; align-items: center;font-size: 12px; font-weight: 400; line-height: 11.7px; color: #FFFFFF;">
							<div class=""
								style="width: 180px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
							<div class=""
								style="width: 180px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
						</div>
						<div style="margin-top: 7px;display: flex; justify-content: space-around; align-items: center;">
							<div style="width: 180px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
							<div style="width: 180px;">
								<el-progress :percentage="40" :stroke-width="10" :text-inside="false"
									:show-text="false"></el-progress>
							</div>
						</div>
						<div class=""
							style="margin-top: 3px;display: flex; justify-content: space-around; align-items: center;font-size: 12px; font-weight: 400; line-height: 11.7px; color: #FFFFFF;">
							<div class=""
								style="width: 180px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
							<div class=""
								style="width: 180px;display: flex; justify-content: space-between; align-items: center;">
								<div>关 0%</div>
								<div style="color: #1587FA;">40%</div>
								<div>开 100%</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 60%;height: 349px;
			background: url('https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1721031354673.png')no-repeat;
			background-size: 100% 100%;">
				<div style="padding: 0px 40px;">
					<div class=""
						style="font-size: 18px; font-weight: 500; line-height: 19px; display: flex; align-items: center;">
						<div style="color: #FFFFFF;">
							{{remoteDeviceListOptFor.remoteDeviceName}}
						</div>
						<div v-if="remoteDeviceListOptFor.remoteDeviceState==2" style="margin-left: 8px;color: #00FFE7;display: flex;align-items: center;">
							已开启 <h1 style="margin-left: 4px;">·</h1>
						</div>
						<div v-else style="margin-left: 8px;color: #ed5565;display: flex;align-items: center;">
							离线 <h1 style="margin-left: 4px;">·</h1>
						</div>
					</div>
					<div class="data-list">
						<div  class=""
							style="margin-bottom: 30px;width: 100%;display: flex;flex-wrap: wrap;line-height: 25px;">
							<div style="width: 25%;margin-bottom: 30px;">
								<div class="text-one">
									阀门1角度
								</div>
								<div class="text-two">
									{{remoteDeviceListOptFor.ballValve12}}度
								</div>
							</div>
							<div style="width: 25%;margin-bottom: 30px;">
								<div class="text-one">
									阀门2角度
								</div>
								<div class="text-two">
									{{remoteDeviceListOptFor.ballValve11}}度
								</div>
							</div>
							<div style="width: 25%;margin-bottom: 30px;">
								<div class="text-one">
									阀门压力1
								</div>
								<div class="text-two">
									{{remoteDeviceListOptFor.ballValve6}}pa
								</div>
							</div>
							<div style="width: 25%;margin-bottom: 30px;">
								<div class="text-one">
									阀门压力2
								</div>
								<div class="text-two">
									{{remoteDeviceListOptFor.ballValve5}}pa
								</div>
							</div>
							<div style="width: 25%;margin-bottom: 30px;">
								<div class="text-one">
									压力报警值1
								</div>
								<div class="text-two">
									{{remoteDeviceListOptFor.ballValve4}}Kpa
								</div>
							</div>
							<div style="width: 25%;margin-bottom: 30px;">
								<div class="text-one">
									压力报警值2
								</div>
								<div class="text-two">
									{{remoteDeviceListOptFor.ballValve3}}Kpa
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript"
	src="https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.CitySearch"></script>
<script>
	export default {
		name: "app",
		props: {
			// 当前活动tab的索引
			devItem: {
				type: Object,
				default () {
					return {};
				},
			},
			remoteDeviceListOptFor: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				devType: 'dev-zt1_2',
				fertilizerDeviceList: [],
				onlineNum: 0,
				offlineNum: 0,
				fertilizerDeviceListOptFor: "",
				loadingType: false,
				userInfo: {},
				value: "",
			};
		},
		watch: {
			'remoteDeviceListOptFor': {
				handler: function(newVal, oldVal) {
					// 监听到fertilizerDeviceListOptFor变化后的操作
					// 可以在这里调用loadingEvent和newDataList等方法
					console.log('remoteDeviceListOptFor-newVal', newVal)
					this.newMap(newVal.ballLon);
					// console.log('oldVal',oldVal)
					// this.fertilizerMassifName = JSON.parse(newVal.fertilizerMassifName);
					// this.show = false;
					// let that = this;
					// setTimeout(function() {
					// 	that.show = true;
					// 	setTimeout(function() {
					// 		that.setSVGViewBox();
					// 		that.getFertilizerDevices();
					// 	}, 10);
					// }, 1);
				},
				deep: true // 深度监听对象内部值的变化
			}
		},
		async mounted() {
			console.log('====================waters', this.remoteDeviceListOptFor)

			// 从本地缓存中获取数据
			let userInfo = localStorage.getItem("user_info");
			// 将获取到的JSON字符串转换回对象
			this.userInfo = JSON.parse(userInfo);
			// console.log("info===", this.userInfo);
			// this.getFertilizerDevice();
			this.newMap();
		},
		methods: {
			//地图
			newMap(ballLon) {
				let lngLat = [0, 0];
				if (ballLon) {
					lngLat[0] = ballLon.split(',')[0];
					lngLat[1] = ballLon.split(',')[1];
				}
				const scripts = [
					"https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=Map3D",
					// "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6",
					// 'https://a.amap.com/jsapi_demos/static/resource/heatmapData.js'
				];
				scripts.forEach((src) => {
					const script = document.createElement("script");
					script.src = src;
					script.onload = () => {
						// 外部 JS 文件加载成功后的回调函数
						// console.log('气象newMap加载成功');

						// 这是中心点的经纬度
						// 业务中应该是获取当前位置
						this.map = new AMap.Map("container", {
							// resizeEnable: true,
							// center: this.devItem.devicelat ? lngLat : [103.83, 36.06], // 初始化地图中心点
							// zoom: this.devItem.devicelat ? 8 : 3, //初始化地图层级
							// mapStyle: "amap://styles/whitesmoke",
							center: ballLon ? lngLat : [103.83, 36.06], // 初始化地图中心点
							zoom: ballLon ? 15 : 13, //初始化地图层级
							mapStyle: "amap://styles/fresh",
							features: ["road", "bg"],
						});

						let satellite = new AMap.TileLayer.Satellite({
							map: this.map,
						});
						if (ballLon) {
							// 点标记显示内容，HTML要素字符串
							// <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701763768056.png">
							const markerContent =
								"" +
								'<div class="">' +
								'   <img style="widht: 28.24px;height: 45.66px;" src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1721288304377.png">' +
								"</div>";
							const position = new AMap.LngLat(lngLat[0], lngLat[1]); // Marker经纬度
							const marker = new AMap.Marker({
								position: position,
								content: markerContent, // 将 html 传给 content
								offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
							});
							this.map.add(marker);
						}
					};
					script.onerror = (err) => {
						// 外部 JS 文件加载失败后的回调函数
						// console.log('气象newMap加载失败', err);
					};
					document.head.appendChild(script);
				});
			},
			//
			change(e) {
				console.log("change==", e);
			},
			loadingEvent(loadingType) {
				this.loadingType = loadingType;
			},
			async optForFertilizerDeviceList(item) {
				if (item.fertilizerDeviceState == 2) {
					if (this.loadingType) {
						this.$message({
							message: "数据加载中，请稍后尝试！",
							type: "warning",
						});
						return;
					}
					this.fertilizerDeviceListOptFor = item;
					this.$forceUpdate();
					// await this.getFertilizerDevices();
				}
			},
			changDevice(type) {
				//切换设备列表
				let div = document.querySelector("#title-img-tab1");
				let div1 = document.querySelector("#title-img-tab2");
				if (type == 0) {
					div.style.background = "#2C83EF";
					div1.style.background = "transparent";
				} else {
					div1.style.background = "#2C83EF";
					div.style.background = "transparent";
				}
			},
			getFertilizerDevice() {
				//水肥设备
				this.fertilizerDeviceList = [];
				this.onlineNum = 0;
				this.offlineNum = 0;
				let httpData = {
					hothouseDeviceMid: "",
					pageNum: 1,
					pageSize: 10,
					deptId: this.userInfo.deptId,
				};
				this.$axios
					.get("/fertilizerDevice/list", {
						params: httpData,
					})
					.then((data) => {
						console.log("查水肥设备---fertilizerDevice---res", data);
						let res = data.data;
						for (let i in res) {
							this.fertilizerDeviceList.push(res[i]);
							if (res[i].fertilizerDeviceState != 2) {
								this.offlineNum += 1;
							} else {
								this.onlineNum += 1;
							}
						}
						if (this.fertilizerDeviceList.length != "0") {
							// 数据不为空时，默认选中在线第一个
							for (let i = 0; i < this.fertilizerDeviceList.length; i++) {
								if (this.fertilizerDeviceList[i].fertilizerDeviceState == 2) {
									this.fertilizerDeviceListOptFor = this.fertilizerDeviceList[i];
									this.$forceUpdate();
									break;
								}
							}
						}
					})
					.catch((error) => {
						console.log("---fertilizerDevice---error===", error);
					});
			},
		},
	};
</script>

<style scoped>
	#container {
		width: 100%;
		height: 100%;
	}

	.title-img {
		width: 30%;
		height: 40px;
		background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181612497.png");
		background-size: 100% 100%;
	}

	.title {
		padding-left: 30px;
		position: relative;
		top: -8px;
	}

	.data-list {
		overflow: scroll;
		width: 100%;
		height: 260px;
	}

	.data-list::-webkit-scrollbar {
		display: none
	}

	.text-one {
		font-size: 16px;
		font-weight: bold;
		color: #FFFFFF;
	}

	.text-two {
		font-size: 14px;
		font-weight: 400;
		color: #C5C5C5;
	}
</style>